export default class CalendarTimeFrame{

    StartTime = null
    EndTime = null
    IsSelected = false
    TimesheetEntry = null
    IsTimesheetEntryHeader = false
    DivId = ""

    constructor(startTime, endTime) {
    this.StartTime = startTime;
    this.EndTime = endTime;
  }
}